import * as React from 'react';

/** Material UI Packages. */
import { Box, useMediaQuery, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts';

export default function ResultChart(props) {
    /** Get props from Performance.js */
    const { laborChartData, laborChartLabel } = props;

    /** Responsive breakpoints for dynamic chart sizing */
    const isMedium = useMediaQuery('(max-width:1800px)');
    const isSmall = useMediaQuery('(max-width:1440px)');

    return (
        <Box
            sx={{
                borderRadius: '18px',
                boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.16)',
                mb: 2,
                height: '100%',
                p: 1,
            }}
        >
            {laborChartData.length > 0 ? (
                <>
                    <Typography
                        sx={{ fontSize: 15, textAlign: 'center', color: '#003a52', fontWeight: 500, width: '100%' }}
                    >
                        Employee Labor Index Overview
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'cennter',
                        }}
                    >
                        <LineChart
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    data: laborChartLabel,
                                },
                            ]}
                            series={[{ data: laborChartData, color: 'rgba(0, 101, 126, 0.5)' }]}
                            width={isSmall ? 650 : isMedium ? 900 : 1050}
                            height={isSmall ? 600 : isMedium ? 640 : 720}
                            grid={{ horizontal: true }}
                        />
                    </Box>
                </>
            ) : (
                <Box
                    sx={{
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 17,
                            fontWeight: 500,
                            color: '#003a52',
                            textAlign: 'center',
                            justifyItems: 'center',
                        }}
                    >
                        Please enter the information of the employee you’re looking for.
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
